exports.ID = 'id'
exports.NAME = 'name'
exports.COUNTRY = 'country'
exports.STATE = 'state'
exports.CITY = 'city'
exports.CONTACT_NAME = 'contactName'
exports.CONTACT_EMAIL = 'contactEmail'
exports.WEBSITE = 'website'
exports.IS_DEFAULT = 'isDefault'
exports.DISTRICT = 'district'
exports.ADDRESS = 'address'
exports.ZIPCODE = 'zipcode'
exports.MACHINE_COUNT = 'machineCount'

exports.ERROR_TYPE = 'errorType' // property
exports.ERROR_TYPE_NO_ORGANIZATION_FOUND = 'noOrganizationFound' // value
